import React, { useState } from 'react';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import classnames from 'classnames';
import { Form, Formik } from "formik";
import { gamificationSchema } from '../../../../models/gamification/gamificationSchema';
import { gamificationDefaults } from '../../../../models/gamification/gamificationDefaults';
import GamificationAttendancePoints from "./GamificationAttendancePoints";
import GamificationAttendanceMilestones from "./GamificationAttendanceMilestones";
import GamificationLevelRanks from './GamificationLevelRanks';
import GamificationGraduation from "./GamificationGraduation";
import { NeoCard, NeoButton, NeoAlert } from '../../../../components/Common';

const TABS = [
    { id: '1', icon: 'mdi-calendar-check-outline', label: 'Frequência' },
    { id: '2', icon: 'mdi-medal-outline', label: 'Graduação' },
    { id: '3', icon: 'mdi-crown-outline', label: 'Ranking' },
];

const GamificationForm = ({ initialData, onSave, isSaving }) => {
    const [activeTab, setActiveTab] = useState('1');
    const formValues = { 
        ...gamificationDefaults, 
        ...initialData,
        achievements: initialData?.achievements?.length > 0 ? initialData.achievements : gamificationDefaults.achievements,
        levelRanks: initialData?.levelRanks?.length > 0 ? initialData.levelRanks : gamificationDefaults.levelRanks
    };

    return (
        <Formik
            enableReinitialize
            initialValues={formValues}
            validationSchema={gamificationSchema}
            onSubmit={(values, { setSubmitting }) => {
                onSave(values);
                setSubmitting(false);
            }}
        >
            {({ isSubmitting, isValid, submitCount, values, setFieldValue }) => (
                <Form className="neo-font-outfit">
                    {/* Top Navigation Bar - compact horizontal tabs */}
                    <div className="d-flex align-items-center justify-content-between mb-4 flex-wrap gap-2">
                        <Nav tabs className="status-tabs-nav gap-1 flex-nowrap overflow-auto flex-grow-1" style={{ scrollbarWidth: 'none' }}>
                            {TABS.map(tab => (
                                <NavItem key={tab.id}>
                                    <NavLink
                                        className={classnames(
                                            'status-tab-link border-0 d-flex align-items-center gap-2',
                                            { 'active': activeTab === tab.id }
                                        )}
                                        onClick={() => setActiveTab(tab.id)}
                                        style={{
                                            whiteSpace: 'nowrap',
                                        }}
                                    >
                                        <i className={`mdi ${tab.icon} font-size-16`}></i>
                                        <span>{tab.label}</span>
                                    </NavLink>
                                </NavItem>
                            ))}
                        </Nav>
                        <NeoButton 
                            type="submit" 
                            variant="primary" 
                            className="px-5 fw-bold shadow-sm"
                            loading={isSaving || isSubmitting}
                            loadingText="Salvando..."
                            icon="mdi-content-save-outline"
                        >
                            Salvar Alterações
                        </NeoButton>
                    </div>

                    {submitCount > 0 && !isValid && (
                        <NeoAlert variant="danger" className="mb-4">
                            Existem campos obrigatórios com erros. Verifique as abas.
                        </NeoAlert>
                    )}

                    <NeoCard bodyClassName="p-4">
                        <TabContent activeTab={activeTab}>
                            {/* TAB 1 - Frequência */}
                            <TabPane tabId="1">
                                <GamificationAttendancePoints values={values} setFieldValue={setFieldValue} />
                                <GamificationAttendanceMilestones values={values} setFieldValue={setFieldValue} />
                            </TabPane>

                            {/* TAB 2 - Graduação */}
                            <TabPane tabId="2">
                                <GamificationGraduation values={values} setFieldValue={setFieldValue} />
                            </TabPane>

                            {/* TAB 3 - Ranking de Níveis */}
                            <TabPane tabId="3">
                                <GamificationLevelRanks values={values} setFieldValue={setFieldValue} />
                            </TabPane>
                        </TabContent>
                    </NeoCard>
                </Form>
            )}
        </Formik>
    );
};

export default GamificationForm;
